"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("@material-ui/core/Button"); // So we don't have any override priority issue.
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importStar(require("react"));
var styles_1 = require("../styles");
var styles = {
    /* Styles applied to the root element. */
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: 8,
    },
    /* Styles applied to the root element if `disableSpacing={false}`. */
    spacing: {
        '& > * + *': {
            marginLeft: 8,
        },
    },
};
var UnstyledCompactAccordionActions = (0, react_1.forwardRef)(function CompactAccordionActions(_a, ref) {
    var _b;
    var classes = _a.classes, className = _a.className, disableSpacing = _a.disableSpacing, other = __rest(_a, ["classes", "className", "disableSpacing"]);
    return (react_1.default.createElement("div", __assign({ className: (0, clsx_1.default)(classes.root, (_b = {}, _b[classes.spacing] = !disableSpacing, _b), className), ref: ref }, other)));
});
var CompactAccordionActions = (0, styles_1.withStyles)(styles, { name: 'CompactAccordionActions' })(UnstyledCompactAccordionActions);
exports.default = CompactAccordionActions;
//# sourceMappingURL=CompactAccordionActions.js.map